import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ItemForm from '../../../components/forms/ItemForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/items/GetBasicAction'
import PutAction from '../../../actions/items/PutAction'
import ListLocationsAction from '../../../actions/locations/ListLinearAction'
import ListCompartmentsAction from '../../../actions/compartments/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class UpdateItemPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.id)
    this.props.fetchLocations()
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur cette pièce.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Pièce modifiée.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header='Modifier une pièce'
        body={
          <ItemForm
            data={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.saveError}
            product={this.props.product}
            withNumber={this.props.withNumber}
            locationsList={this.props.locationsList}
            locationsIsFetching={this.props.locationsIsFetching}
            fetchCompartments={this.props.fetchCompartments}
            compartmentsList={this.props.compartmentsList}
            compartmentsIsFetching={this.props.compartmentsIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

UpdateItemPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  withNumber: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  locationsList: PropTypes.array,
  locationsIsFetching: PropTypes.bool.isRequired,
  compartmentsList: PropTypes.array,
  compartmentsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  get: PropTypes.func.isRequired,
  put: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  fetchCompartments: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.items.get.basic.data,
    isLoading: state.entities.items.get.basic.isFetching,
    loadError: state.entities.items.get.basic.error,
    isSaving: state.entities.items.put.isFetching,
    saveError: state.entities.items.put.error,
    locationsList: state.entities.locations.list.linear.data,
    locationsIsFetching: state.entities.locations.list.linear.isFetching,
    compartmentsList: state.entities.compartments.list.data,
    compartmentsIsFetching: state.entities.compartments.list.isFetching
  }),
  (dispatch) => ({
    get: (id) => (dispatch(GetAction({ id }))),
    put: (id, data) => (dispatch(PutAction({ id, data }))),
    fetchLocations: () => (dispatch(ListLocationsAction({}))),
    fetchCompartments: (id) => (dispatch(ListCompartmentsAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.ITEMS.PUT)))
  })
)(UpdateItemPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/items/UpdateItemPopup.js